// @ts-nocheck
import React, { FunctionComponent, useState, useEffect } from 'react'
import { get } from 'lodash'
import { SPOTIFY_OPEN, TIKTOK_MUSIC, TIKTOK_VM } from 'Constants/urls'
import { useTranslation } from 'react-i18next'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { WhiteGreenBtn } from 'Stories/Button/Button.stories'
import { DottedBtn } from 'Stories/DottedBtn/DottedBtn.stories'
import closeCross from 'Shared/icons/close-cross.svg'
import { Desktop, Mobile } from 'Shared/components/Responsive'
import CustomScrollDiv from 'Shared/custom/CustomScrollDiv'
import { IconArrow } from 'Stories/Icon/Icon.stories'
import {
  getSpotifyTrack as onGetSpotifyTrack,
  getSpotifyTracks as onGetSpotifyTracks,
  getTikTokTrack,
  getTikTokTrackWithoutAuth,
  setTikTokToTrack,
  setTracksToInitialState,
} from 'Redux/actions/trackActions'
import {
  checkAlbumToCreateCampaign as onCheckAlbum,
  checkTrackToCreateCampaign as onCheckTrack,
} from 'Redux/actions/campaignActions'

import {
  CampaignPlatformTypeEnum,
  Error,
  SpotifyTrack,
  TikTokTrack,
} from '../../Types'
import AddSearchTrackForm from '../AddSearchTrackForm'
import CheckTrackFromSearch from '../CheckTrackFromSearch'
import SuccessfulyAddedTrack from '../SuccessfulyAddedTrack'
import ModalLayout from '../ModalLayout'

import { AddTrackSearchModalProps } from './AddTrackSearchModalProps'

import {
  AddTrackInfo,
  AddTrackInfoDescr,
  AddTrackInfoTitle,
  AddTrackItem,
  AddTrackUrl,
  Arrow,
  ChangeSpotifyBlockDesktop,
  ChangeSpotifyBlockMobile,
  MobileModal,
  SmallButton,
  SpotifyUrlFormWrapper,
  WrapperForCloseBtn,
  WrapperRelative,
} from './styles'

const AddTrackSearchModal: FunctionComponent<AddTrackSearchModalProps> = ({
  track,
  tracks,
  setCurTiktokUrl,
  errorText,
  btnTitle,
  modalHeader,
  modalSubHeader,
  campaignType,
}) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()

  const isFirstCampaign: boolean = useSelector(
    (state: RootStateOrAny) => state.auth.user.is_first_campaign
  )
  const accessToken =
    'BQCzo5e2HvGiM5LF2DCbeyb-yVQHzo7oZTUsfoJmU0Dx6-ZEzuLJ_oQ34w0gk9i8uGFCvHiyOLJjnBKQW-7wzXr5OhUUJ33RXZ5Gs1wz1q-41OrOLdxkEurr8tXuCjDfaPDE52TayQprkZClwAqLumN5zkmoIBqYFIacjeHrJvkpmjy1sTm8JFdTGyR1wfWfWjJCfua10ZiHPo4BnZm6w-h5'
  const spotifyTrack: SpotifyTrack = useSelector(
    (state: RootStateOrAny) => state.spotifyTrack.track
  )

  const tikTokTrack: TikTokTrack = useSelector(
    (state: RootStateOrAny) => state.tikTokTrack.tikTokTrack
  )

  const credentials = useSelector(
    (state: RootStateOrAny) => state.auth.credentials
  )
  const isAuth = Boolean(credentials.AccessToken)

  const [isChangedTrack, setIsChangedTrack] = useState<boolean>(false)
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const [searchValue, setSearchValue] = useState<string>('')
  const [
    searchedTiktokTrack,
    setSearchedTiktokTrack,
  ] = useState<TikTokTrack | null>(null)
  const [isSearchError, setSearchError] = useState<boolean>(false)
  const [isErrorAnswerSpotify, setErrorAnswerSpotify] = useState<boolean>(false)
  const [isSameTrackError, setSameTrackError] = useState<boolean>(false)
  const [isSearchErrorTiktok, setSearchErrorTiktok] = useState<boolean>(false)
  const [isErrorAnswerTiktok, setErrorAnswerTiktok] = useState<boolean>(false)
  const [isSameTrackErrorTiktok, setSameTrackErrorTiktok] = useState<boolean>(
    false
  )
  const [isTiktokLoading, setTiktokLoading] = useState<boolean>(false)

  const toggle = () => setIsVisible(!isVisible)

  const setGTMeventSpotify = spotifyTrack => {
    // trackAddedEventSpotify(spotifyTrack, Boolean(isFirstCampaign))
  }

  // TODO add debounce and sagas
  const onSearchSpotifyTrack = (searchString: string): void => {
    // search by link
    let apiUrl: string

    if (searchString?.includes(SPOTIFY_OPEN)) {
      const index = searchString.indexOf('track')

      const trackID = searchString
        .substring(index)
        .slice(6)
        .substring(0, 22)

      apiUrl = `https://api.spotify.com/v1/tracks/${trackID}`
    } else {
      // search by track name
      apiUrl = `https://api.spotify.com/v1/search?q=${searchString}&type=artist,track`
    }

    apiUrl &&
      dispatch(
        onGetSpotifyTracks(apiUrl, accessToken, (error: Error) => {
          if (error) {
            const errorMessage = get(error, 'error.message', null)
            if (errorMessage === 'The access token expired') {
              setSearchError(true)
            } else {
              setErrorAnswerSpotify(true)
            }
          }
        })
      )
  }

  const onSearchTiktokTrack = (searchString: string): void => {
    const isTrackLink =
      searchString?.includes(TIKTOK_MUSIC) || searchString?.includes(TIKTOK_VM)

    if (isTrackLink && isAuth) {
      dispatch(
        getTikTokTrack(searchString, (error, payload) => {
          setTiktokLoading(true)
          if (error) {
            const errorStatus = error?.statusCode || null
            if (errorStatus === 409) {
              setSameTrackError(true)
            } else {
              setErrorAnswerTiktok(true)
            }
          }
          if (payload) {
            if (setCurTiktokUrl) setCurTiktokUrl(searchString)
            setSearchedTiktokTrack(payload)
            setErrorAnswerTiktok(false)
            setSameTrackErrorTiktok(false)
            setSearchErrorTiktok(false)
          }
          setTiktokLoading(false)
        })
      )
    } else if (isTrackLink && !isAuth) {
      dispatch(
        getTikTokTrackWithoutAuth(searchString, (error, payload) => {
          setTiktokLoading(true)
          if (error) {
            const errorStatus = error?.statusCode || null
            if (errorStatus === 409) {
              setSameTrackError(true)
            } else {
              setErrorAnswerTiktok(true)
            }
          }
          if (payload) {
            if (setCurTiktokUrl) setCurTiktokUrl(searchString)
            setSearchedTiktokTrack(payload)
            setErrorAnswerTiktok(false)
            setSameTrackErrorTiktok(false)
            setSearchErrorTiktok(false)
          }
          setTiktokLoading(false)
        })
      )
    } else {
      setErrorAnswerTiktok(true)
    }
  }

  useEffect(() => {
    if (searchValue.length === 0) return
    campaignType === CampaignPlatformTypeEnum.SPOTIFY &&
      onSearchSpotifyTrack(searchValue)

    campaignType === CampaignPlatformTypeEnum.TIKTOK &&
      onSearchTiktokTrack(searchValue)
  }, [searchValue])

  const handleSubmit = () => {
    if (campaignType === CampaignPlatformTypeEnum.SPOTIFY) {
      const isTrackLink = searchValue.includes('track')
      if (accessToken && isTrackLink) {
        const index = searchValue.indexOf('track')
        const trackID = searchValue
          .substring(index)
          .slice(6)
          .substring(0, 22)
        const apiURL = `https://api.spotify.com/v1/tracks/${trackID}`

        if (isAuth) {
          dispatch(
            onCheckTrack(apiURL, error => {
              if (!error) {
                dispatch(
                  onGetSpotifyTrack(apiURL, accessToken, (error, res) => {
                    if (error) {
                      const errorMessage = get(error, 'error.message', null)
                      if (errorMessage === 'The access token expired') {
                        setSearchError(true)
                      } else {
                        setErrorAnswerSpotify(true)
                      }
                    } else {
                      setGTMeventSpotify(res)
                    }
                  })
                )
              } else {
                setSameTrackError(true)
              }
            })
          )
        } else {
          dispatch(
            onGetSpotifyTrack(apiURL, accessToken, (error, res) => {
              if (error) {
                const errorMessage = get(error, 'error.message', null)
                if (errorMessage === 'The access token expired') {
                  setSearchError(true)
                } else {
                  setErrorAnswerSpotify(true)
                }
              } else {
                setGTMeventSpotify(res)
              }
            })
          )
        }
      } else if (accessToken && !isTrackLink) {
        const index = searchValue.indexOf('album')
        const albumID = searchValue
          .substring(index)
          .slice(6)
          .substring(0, 22)

        dispatch(
          onCheckAlbum(albumID, error => {
            if (error) {
              setSearchError(true)
            }
          })
        )
      }
      setSearchValue('')
      dispatch(setTracksToInitialState())
    }
  }

  const handleSetSearchToInitial = () => {
    if (campaignType === CampaignPlatformTypeEnum.TIKTOK) {
      setSearchedTiktokTrack(null)
      dispatch(setTikTokToTrack(false))
    } else {
      dispatch(setTracksToInitialState())
    }
    setSearchValue('')
  }

  const handleCheck = (apiURL: string) => {
    if (campaignType === CampaignPlatformTypeEnum.TIKTOK) {
      dispatch(setTikTokToTrack(true))
      setSearchValue('')
      setSearchedTiktokTrack(null)
      isChangedTrack && setIsChangedTrack(false)
    } else if (campaignType === CampaignPlatformTypeEnum.SPOTIFY) {
      if (accessToken) {
        if (isAuth) {
          dispatch(
            onCheckTrack(apiURL, error => {
              if (!error) {
                setIsChangedTrack(false)
                dispatch(
                  onGetSpotifyTrack(apiURL, accessToken, (error, res) => {
                    if (error) {
                      const errorMessage = get(error, 'error.message', null)
                      if (errorMessage === 'The access token expired') {
                        setSearchError(true)
                      } else {
                        setErrorAnswerSpotify(true)
                      }
                    } else {
                      setGTMeventSpotify(res)
                    }
                  })
                )
                handleSetSearchToInitial()
              } else {
                setSameTrackError(true)
                dispatch(setTracksToInitialState())
              }
            })
          )
        } else {
          dispatch(
            onGetSpotifyTrack(apiURL, accessToken, (error, res) => {
              if (error) {
                const errorMessage = get(error, 'error.message', null)
                if (errorMessage === 'The access token expired') {
                  setSearchError(true)
                } else {
                  setErrorAnswerSpotify(true)
                }
              } else {
                setIsChangedTrack(false)
                setGTMeventSpotify(res)
              }
            })
          )
          handleSetSearchToInitial()
        }
      }
    }
  }

  const handleChangeSpotifyTrack = () => {
    if (campaignType === CampaignPlatformTypeEnum.TIKTOK) {
      setSearchedTiktokTrack(null)
      setIsChangedTrack(true)
      setSearchErrorTiktok(false)
      setErrorAnswerTiktok(false)
      setSameTrackErrorTiktok(false)
    } else {
      setIsChangedTrack(true)
      setSearchError(false)
      setErrorAnswerSpotify(false)
      setSameTrackError(false)
    }
    toggle()
  }

  return (
    <>
      {track ? (
        <>
          <Desktop>
            <ChangeSpotifyBlockDesktop>
              <DottedBtn
                content={t('createCampaignPage.changeSpotifyTrack')}
                onClick={handleChangeSpotifyTrack}
              />
            </ChangeSpotifyBlockDesktop>
          </Desktop>
          <Mobile>
            {campaignType === CampaignPlatformTypeEnum.TIKTOK ? (
              <AddTrackItem>
                <AddTrackInfo>
                  <AddTrackUrl
                    alt="Track cover"
                    src={tikTokTrack?.trackCoverUrl}
                  />
                  <AddTrackInfoDescr>
                    <AddTrackInfoTitle>
                      {tikTokTrack?.trackTitle}
                    </AddTrackInfoTitle>
                    <div>{tikTokTrack?.trackAuthorName}</div>
                  </AddTrackInfoDescr>
                </AddTrackInfo>
              </AddTrackItem>
            ) : (
              <AddTrackItem>
                <AddTrackInfo>
                  <AddTrackUrl
                    alt="Track cover"
                    src={spotifyTrack?.album?.images[0].url}
                  />
                  <AddTrackInfoDescr>
                    <AddTrackInfoTitle>{spotifyTrack?.name}</AddTrackInfoTitle>
                    <div>{spotifyTrack?.artists[0].name}</div>
                  </AddTrackInfoDescr>
                </AddTrackInfo>
              </AddTrackItem>
            )}

            <ChangeSpotifyBlockMobile>
              <DottedBtn
                content={t('createCampaignPage.changeSpotifyTrack')}
                onClick={handleChangeSpotifyTrack}
              />
            </ChangeSpotifyBlockMobile>
          </Mobile>
        </>
      ) : (
        <WhiteGreenBtn color="whiteGreen" onClick={toggle}>
          {btnTitle}
        </WhiteGreenBtn>
      )}

      <Desktop>
        <ModalLayout
          content={modalHeader}
          visible={isVisible}
          width={600}
          handleClose={toggle}
        >
          <>
            {!track || isChangedTrack ? (
              <AddSearchTrackForm
                isTiktokLoading={isTiktokLoading}
                errorText={errorText}
                modalSubHeader={modalSubHeader}
                search={searchValue}
                searchError={isSearchError || isSearchErrorTiktok}
                errorAnswerSpotify={isErrorAnswerSpotify || isErrorAnswerTiktok}
                sameTrackError={isSameTrackError || isSameTrackErrorTiktok}
                onSubmit={handleSubmit}
                onChange={setSearchValue}
              />
            ) : (
              <SuccessfulyAddedTrack toggle={toggle} />
            )}

            {(tracks || searchedTiktokTrack) && (
              <WrapperRelative>
                <CustomScrollDiv length={tracks?.length || 1}>
                  <CheckTrackFromSearch
                    tikTokTrack={searchedTiktokTrack}
                    tracks={tracks}
                    onCheck={handleCheck}
                  />
                </CustomScrollDiv>
              </WrapperRelative>
            )}
          </>
        </ModalLayout>
      </Desktop>

      <Mobile>
        <MobileModal
          fade={false}
          isOpen={isVisible}
          modalClassName="modal__mobile"
          toggle={toggle}
        >
          <SpotifyUrlFormWrapper>
            <>
              {!track || isChangedTrack ? (
                <>
                  <Arrow type="button" onClick={toggle}>
                    <IconArrow />
                  </Arrow>
                  <AddSearchTrackForm
                    errorText={errorText}
                    modalSubHeader={modalSubHeader}
                    search={searchValue}
                    searchError={isSearchError || isSearchErrorTiktok}
                    errorAnswerSpotify={
                      isErrorAnswerSpotify || isErrorAnswerTiktok
                    }
                    sameTrackError={isSameTrackError || isSameTrackErrorTiktok}
                    onSubmit={handleSubmit}
                    onChange={setSearchValue}
                  />
                </>
              ) : (
                <SuccessfulyAddedTrack toggle={toggle} />
              )}

              {(tracks || searchedTiktokTrack) && (
                <WrapperForCloseBtn>
                  <SmallButton onClick={handleSetSearchToInitial}>
                    <img src={closeCross} alt="clear-button" />
                  </SmallButton>
                </WrapperForCloseBtn>
              )}
            </>

            {(tracks || searchedTiktokTrack) && (
              <CustomScrollDiv length={tracks?.length || 1}>
                <CheckTrackFromSearch
                  tikTokTrack={searchedTiktokTrack}
                  tracks={tracks}
                  onCheck={handleCheck}
                />
              </CustomScrollDiv>
            )}
          </SpotifyUrlFormWrapper>
        </MobileModal>
      </Mobile>
    </>
  )
}

export default AddTrackSearchModal
